export const BASE_URL = 'https://public-api.lonescale.com';
